/**
 * Visitor consent for the marketing site's analytics and advertising tags.
 * Stored in a first-party cookie so the server (Conversions API relay, contact
 * form) honours the same choice as the browser, including a later withdrawal.
 * Nothing loads and nothing is relayed until the visitor accepts.
 */
export const MARKETING_CONSENT_COOKIE = 'af_consent';

const CONSENT_VERSION = 1;
const CONSENT_MAX_AGE_SECONDS = 180 * 24 * 60 * 60;

export interface MarketingConsent {
  analytics: boolean;
  advertising: boolean;
}

export function serializeMarketingConsent(consent: MarketingConsent): string {
  return [
    `v${CONSENT_VERSION}`,
    consent.analytics ? 'a1' : 'a0',
    consent.advertising ? 'd1' : 'd0',
  ].join('.');
}

/** Returns null for a missing, malformed or outdated value: no choice made. */
export function parseMarketingConsent(
  value: string | null | undefined,
): MarketingConsent | null {
  if (!value) return null;

  const match = /^v(\d+)\.a([01])\.d([01])$/.exec(value);

  if (!match || Number(match[1]) !== CONSENT_VERSION) return null;

  return { analytics: match[2] === '1', advertising: match[3] === '1' };
}

export function marketingConsentCookie(consent: MarketingConsent): string {
  return `${MARKETING_CONSENT_COOKIE}=${serializeMarketingConsent(consent)}; Path=/; Max-Age=${CONSENT_MAX_AGE_SECONDS}; SameSite=Lax; Secure`;
}
